import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7626ad4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增资源")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出权限用户")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看用户")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import { ElMessage, ElMessageBox } from 'element-plus'
import {exportHandle} from '@/utils/index'
import Api from "@/http/modules/index"

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'GET/resources': fetchList,
  // created resources
  'POST/resources': createdResourcesApi,
  // delete resources
  'DELETE/resources/{id}': delResourcesApi,
  // modify resources
  'PUT/resources': resourcesModifyApi,
  // 查看拥有资源用户
  'GET/resources/{id}/use': resourceUseListApi,
  // 获取创建资源权限多选
  'GET/resources/actions': resourcesActionsApi,
  // 导出资源使用情况列表
  'POST/resources/use/export': exportApi,
  // 资源权限 删除用户
  'DELETE/resources_user/user': userDelPerApi,
} = Api

const {
  MI_height,  MI_tableData, fetchData, 
  MI_identify, MI_params, MI_modifyForm, 
} = new tbMix(fetchList)
const seleRows: any = ref([])


let name = ref<string>('')
const searchHandle = () => {
  fetchData({name: name.value})
}
searchHandle()


let authorityTypeList: any = ref([])
onBeforeMount(async () => {
  authorityTypeList.value = await resourcesActionsApi()
})
let resourcesUseVisiable=ref(false)
let resourcesUseList=ref([])
let useListLoading=ref(false)
// 新增资源
let addFormEle: any = ref()
const addFg = ref<boolean>(false)
const authorityForm = reactive({  id: '', name: '', description: '', actions: [] })
const saveResources = async () => {
  if(authorityForm.actions.length === 0){
    ElMessage.warning('请至少选择一项权限')
    return
  }
  try {
    await createdResourcesApi(authorityForm)
    ElMessage.success('添加成功')
    addFg.value = false
    fetchData()
  } catch (error) {
    addFg.value = false
  }
}

// 编辑资源
const editFg = ref<boolean>(false)
const editForm = reactive({  id: '', name: '', description: '', actions: [] })
const editRowHandle = (row: any) => {
  Object.assign(editForm, {id: row.id, name: row.name, description: row.description, actions: row.actions})
  editFg.value = true
}
const saveEditResources = async () => {
  if(editForm.actions.length === 0){
    ElMessage.warning('请至少选择一项权限')
    return
  }
  try {
    await resourcesModifyApi(editForm)
    ElMessage.success('修改成功')
    editFg.value = false
    fetchData()
  } catch (error) {
    editFg.value = false
  }
}
// 删除
const deleRowHandle = async (row: any) => {
  await ElMessageBox.confirm(
    '确认删除？' + row.name,
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  await delResourcesApi(row)
  ElMessage.success('删除成功')
  fetchData()
}
// 查看使用人员名单
let currentRow = {id: ''}
let viewUseList = (row: any)=>{
  currentRow = row
  useListLoading.value=true
  resourcesUseVisiable.value=true
	resourceUseListApi({id: row.id}).then((res:any)=>{
    resourcesUseList.value=res
    useListLoading.value=false
	}).catch(()=>{
    useListLoading.value=false
  })
}

// 删除员工权限
const delUserPer = (row: any) => {
  ElMessageBox.confirm(`请确认是否删除${row.name}权限`, '提示').then(() => {
    return userDelPerApi({userId: row.userId, resourceId: currentRow.id})
  }).then(() => {
    ElMessage.success('删除成功')
    viewUseList(currentRow)
  })
}

// 导出
const exportAuth = () => {
  MI_identify.value = true
  exportHandle(exportApi, {ids: seleRows.value.map(e => e.id).join(',')}, {contentType: 'formData'}).then(() => {
    ElMessage.success('导出成功')
  }).finally(() => {
    MI_identify.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_el_input, {
      placeholder: "请输入资源名称",
      modelValue: _unref(name),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : name = $event)),
      clearable: "",
      onKeyup: _withKeys(searchHandle, ["enter","native"]),
      class: "form-input",
      onClear: searchHandle,
      disabled: _unref(MI_identify)
    }, null, 8, ["modelValue", "onKeyup", "disabled"]),
    _createVNode(_component_el_button, {
      class: "ml-10",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (searchHandle())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (addFg.value = true)),
      type: "primary",
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Create']
    ]),
    _createVNode(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (exportAuth())),
      disabled: seleRows.value.length === 0 || _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_divider),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      style: {"width":"1200px"},
      "max-height": _unref(MI_height) + 28 + 'px',
      data: _unref(MI_tableData),
      onSelectionChange: _cache[4] || (_cache[4] = (rows) => seleRows.value = rows)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50"
        }),
        _createVNode(_component_el_table_column, {
          label: "资源名",
          prop: "name"
        }),
        _createVNode(_component_el_table_column, {
          label: "资源id",
          prop: "id"
        }),
        _createVNode(_component_el_table_column, {
          label: "权限",
          prop: "actions",
          width: "470"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.actions, (auth) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: auth }, [
                    (auth === 'Manage')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(auth), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (auth === 'Create')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(auth), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (auth === 'Delete')
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              size: "small",
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(auth), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (auth === 'Write')
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 3,
                                size: "small",
                                type: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(auth), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_el_tag, {
                                key: 4,
                                size: "small",
                                type: "info"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(auth), 1)
                                ]),
                                _: 2
                              }, 1024))
                  ], 64))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  onClick: ($event: any) => (editRowHandle(row)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'Write']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  onClick: ($event: any) => (_unref(viewUseList)(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'Write']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (deleRowHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'Delete']
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["max-height", "data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      title: "新增资源",
      width: "910px",
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_unref(addFormEle).resetFields())),
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (saveResources()))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addFormEle",
          ref: addFormEle,
          model: _unref(authorityForm),
          inline: true,
          "label-position": 'top'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "资源Id:",
              prop: "id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(authorityForm).id,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(authorityForm).id) = $event)),
                  placeholder: "请输入资源Id",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "资源名:",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(authorityForm).name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(authorityForm).name) = $event)),
                  placeholder: "请输入资源名",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "描述:",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(authorityForm).description,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(authorityForm).description) = $event)),
                  rows: 1,
                  type: "textarea",
                  placeholder: "请输入描述"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "权限:",
              prop: "actions"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _unref(authorityForm).actions,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(authorityForm).actions) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authorityTypeList), (_auth) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: _auth.name,
                        class: "mb-10",
                        label: _auth.name,
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_auth.description), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑资源",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (saveEditResources()))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(editForm),
          inline: true,
          "label-position": 'top'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "资源Id:",
              prop: "id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(editForm).id,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(editForm).id) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "资源名:",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(editForm).name,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(editForm).name) = $event)),
                  placeholder: "请输入资源名",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "描述:",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(editForm).description,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(editForm).description) = $event)),
                  rows: 1,
                  type: "textarea",
                  placeholder: "请输入描述"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "权限:",
              prop: "actions"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _unref(editForm).actions,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(editForm).actions) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authorityTypeList), (_auth) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        class: "mb-10",
                        key: _auth.name,
                        label: _auth.name,
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_auth.description), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "使用人员名单",
      modelValue: _unref(resourcesUseVisiable),
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(resourcesUseVisiable) ? (resourcesUseVisiable).value = $event : resourcesUseVisiable = $event))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          height: 500,
          data: _unref(resourcesUseList)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "中文名"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(`${row.alias} (${row.name})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "staffType",
              label: "状态"
            }),
            _createVNode(_component_el_table_column, {
              prop: "orgList",
              label: "团队"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (delUserPer(row)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(useListLoading)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})